import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';
import { GridColumns } from '@mui/x-data-grid-pro';
import EditJobPreferencesGridCell from './EditJobPreferencesGridCell';
import { JobMatchesXgridCell } from './JobMatchesXgridCell';
import { JobPreferenceNotificationXgridCell } from './JobPreferenceNotificationXgridCell';
import { JobPreferenceNotificationHeader } from './JobPreferenceNotificationHeader';

export const getJobPrefercesGridColumns = (t): GridColumns => {
  const defaultJobPreferencesColumn = {
    ...XGridDefaultColumn,
    // replace this to have flex column layout for default columns
    // flex: flexColumns ? 1 : 0
    flex: 0,
  };

  return [
    {
      ...defaultJobPreferencesColumn,
      headerName: t('candidate.jobPreferences.preferenceSetName'),
      field: 'preferenceSetName',
      renderCell: EditJobPreferencesGridCell,
      width: 215,
    },
    {
      ...defaultJobPreferencesColumn,
      headerName: t('candidate.jobPreferences.skillSet'),
      field: 'skillSet',
      width: 215,
    },
    {
      ...defaultJobPreferencesColumn,
      headerName: t('candidate.jobPreferences.location'),
      field: 'location',
      width: 300,
    },
    {
      ...defaultJobPreferencesColumn,
      headerName: t('candidate.jobPreferences.shift'),
      field: 'shift',
      width: 175,
    },
    {
      ...defaultJobPreferencesColumn,
      headerName: t('candidate.jobPreferences.notes'),
      field: 'notes',
      width: 215,
    },
    {
      ...defaultJobPreferencesColumn,
      headerName: t('candidate.jobPreferences.jobMatches'),
      field: 'jobMatches',
      renderCell: JobMatchesXgridCell,
      width: 230,
    },
    {
      ...defaultJobPreferencesColumn,
      headerName: t('candidate.jobPreferences.notifications'),
      field: 'notifications',
      renderCell: JobPreferenceNotificationXgridCell,
      width: 175,
      renderHeader: JobPreferenceNotificationHeader,
      description: 'Recieve notifications for new order matches',
    },
  ];
};

export const getJobPreferencesGridVisibilityModel = {
  preferenceSetName: true,
  skillSet: true,
  location: true,
  shift: true,
  notes: true,
  jobMatches: true,
  notifications: true,
};
